"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@angular/common");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const app_service_1 = require("../commons/app.service");
const core_1 = require("@ngx-translate/core");
const BaseComponent_1 = require("../commons/BaseComponent");
const application_events_service_1 = require("../xs/services/events/application-events.service");
const loading_spinner_1 = require("../commons/ui/loading-spinner");
class ForgetComponent extends BaseComponent_1.BaseComponent {
    constructor(service, router, ar, location, snackBar, dialog, translate, applicationEvents) {
        super(router, snackBar, dialog);
        this.service = service;
        this.router = router;
        this.ar = ar;
        this.location = location;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.translate = translate;
        this.pass2 = "";
        this.loading = true;
        this.openEdgeWarningDialog();
        this.service.V.config.clientId = '4dmapper';
        ar.params.subscribe(p => {
            this.tok = p.tok;
            this.service.V.api('/access/forget/' + this.tok).subscribe(s => {
                this.user = s;
                this.loading = false;
                loading_spinner_1.LoadingSpinner.end();
            }, e => {
                this.loading = false;
                loading_spinner_1.LoadingSpinner.end();
                this.error = e;
            });
        });
    }
    resetPass() {
        this.service.V.api('/access/forget/' + this.tok, 'put', this.user).subscribe(s => {
            this.openDialog('SIGNIN.FORGOT_OK').subscribe(s => this.router.navigate(['/auth']));
        }, e => this.openDialog('GENERIC.ERROR', e.message));
    }
}
exports.ForgetComponent = ForgetComponent;
